// extracted by mini-css-extract-plugin
module.exports = {"body":"ShopItem_body__1wGGz","card":"ShopItem_card__kJf4i","bg":"ShopItem_bg__3aKtE"};